import React, { useState, useRef } from "react";
import emailjs from "emailjs-com";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        query: "",
        phone: "",
        email: "",
    });
    const form = useRef();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!form.current) {
            console.error("Form reference is not set.");
            return;
        }

        emailjs
            .sendForm("service_lenorki", "template_id_here", form.current, "YOUR_PUBLIC_KEY")
            .then(
                (response) => {
                    console.log("Email sent successfully:", response.status, response.text);
                    alert("Thank you for reaching out! We will get back to you soon.");
                    setFormData({ query: "", phone: "", email: "" });
                },
                (error) => {
                    console.error("Failed to send email:", error);
                    alert("Failed to send your message. Please try again later.");
                }
            );
    };

    return (
        <div style={styles.container}>
            <h2 style={styles.title}>Contact Us</h2>
            <p style={styles.description}>
                Have a query or want to reach out to us? Fill out the form below or contact us directly.
            </p>
            <form ref={form} onSubmit={handleSubmit} style={styles.form}>
                <textarea
                    name="query"
                    value={formData.query}
                    onChange={handleChange}
                    placeholder="Enter your query here..."
                    required
                    style={styles.textarea}
                />
                <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Phone Number (Optional)"
                    style={styles.input}
                />
                <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Email (Optional)"
                    style={styles.input}
                />
                <button
                    type="submit"
                    style={styles.button}
                    onMouseEnter={(e) => (e.target.style.transform = "scale(1.1)")}
                    onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
                >
                    Submit
                </button>
            </form>
            <div style={styles.contactInfo}>
                <p><strong>Phone:</strong> +91 9311842121</p>
                <p><strong>Email:</strong> contact@scentedethos.in</p>
            </div>
            <div style={styles.manufacturingHub}>
                <h3 style={styles.hubTitle}>Our Manufacturing Hub</h3>
                <p style={styles.hubDescription}>
                    Scented Ethos LLP , plot no 17 , SGP Industrial layout , Bhandara road Nagpur ,440012 
                </p>
            </div>
        </div>
    );
};

const styles = {
    container: {
        padding: "50px",
        backgroundColor: "#f8cee1",
        borderRadius: "15px",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        margin: "50px 0",
        textAlign: "center",
    },
    title: {
        fontSize: "36px",
        fontWeight: "bold",
        color: "#703593",
        marginBottom: "20px",
    },
    description: {
        fontSize: "18px",
        lineHeight: "1.8",
        color: "#415979",
        marginBottom: "40px",
    },
    form: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
    },
    textarea: {
        width: "100%",
        maxWidth: "600px",
        height: "100px",
        padding: "10px",
        borderRadius: "10px",
        border: "1px solid #ccc",
        fontSize: "16px",
        resize: "none",
    },
    input: {
        width: "100%",
        maxWidth: "600px",
        padding: "10px",
        borderRadius: "10px",
        border: "1px solid #ccc",
        fontSize: "16px",
    },
    button: {
        backgroundColor: "#703593",
        color: "#fff",
        padding: "10px 20px",
        borderRadius: "10px",
        border: "none",
        fontSize: "16px",
        cursor: "pointer",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
        transition: "transform 0.3s",
    },
    contactInfo: {
        marginTop: "40px",
        fontSize: "18px",
        color: "#415979",
    },
    manufacturingHub: {
        marginTop: "40px",
        padding: "20px",
        backgroundColor: "#e8f5e9",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
    },
    hubTitle: {
        fontSize: "24px",
        fontWeight: "bold",
        color: "#2e7d32",
        marginBottom: "10px",
    },
    hubDescription: {
        fontSize: "16px",
        color: "#4caf50",
    },
};

export default ContactUs;
